// Bank Config 银行配置相关翻译
export default {
  // 页面标题
  'pages.bank-config.title': '银行配置',
  'pages.bank-config.subtitle': '银行账户配置管理',

  // 表格列
  'pages.bank-config.table.columns.bankName': '银行名称',
  'pages.bank-config.table.columns.accountName': '账户名称',
  'pages.bank-config.table.columns.accountNumber': '账号',
  'pages.bank-config.table.columns.status': '状态',
  'pages.bank-config.table.columns.createTime': '创建时间',
  'pages.bank-config.table.columns.operations': '操作',

  // 操作按钮
  'pages.bank-config.table.actions.view': '查看',
  'pages.bank-config.table.actions.edit': '编辑',
  'pages.bank-config.table.actions.delete': '删除',
  'pages.bank-config.table.actions.add': '新增',

  // 表单字段
  'pages.bank-config.form.fields.bankName': '银行名称',
  'pages.bank-config.form.fields.accountName': '账户名称',
  'pages.bank-config.form.fields.accountNumber': '账号',
  'pages.bank-config.form.fields.status': '状态',
  'pages.bank-config.form.fields.remark': '备注',

  // 表单占位符
  'pages.bank-config.form.placeholder.bankName': '请输入银行名称',
  'pages.bank-config.form.placeholder.accountName': '请输入账户名称',
  'pages.bank-config.form.placeholder.accountNumber': '请输入账号',
  'pages.bank-config.form.placeholder.remark': '请输入备注',

  // 状态
  'pages.bank-config.status.active': '启用',
  'pages.bank-config.status.inactive': '停用',

  // 提示信息
  'pages.bank-config.message.success': '操作成功',
  'pages.bank-config.message.error': '操作失败',
  'pages.bank-config.message.deleteConfirm': '确定要删除该银行配置吗？',

  // 兼容 bankConfig（驼峰）键名
  'pages.bankConfig.table.title': '银行配置',
  'pages.bankConfig.table.columns.name': '银行名称',
  'pages.bankConfig.table.columns.logo': 'Logo',
  'pages.bankConfig.table.columns.description': '描述',
  'pages.bankConfig.table.columns.sort': '排序',
  'pages.bankConfig.table.columns.operations': '操作',
  'pages.bankConfig.actions.add': '新增',
  'pages.bankConfig.actions.edit': '编辑',
  'pages.bankConfig.actions.delete': '删除',
  'pages.bankConfig.confirm.deleteTitle': '删除确认',
  'pages.bankConfig.confirm.deleteContent': '确定要删除银行 "{name}" 吗？',
  'pages.bankConfig.form.createTitle': '新增银行',
  'pages.bankConfig.form.editTitle': '编辑银行',
  'pages.bankConfig.form.nameLabel': '银行名称',
  'pages.bankConfig.form.nameRequired': '请输入银行名称',
  'pages.bankConfig.form.nameMaxLength': '银行名称不能超过 100 个字符',
  'pages.bankConfig.form.namePlaceholder': '请输入银行名称',
  'pages.bankConfig.form.logoLabel': '银行 Logo',
  'pages.bankConfig.form.logoRequired': '请上传银行 Logo',
  'pages.bankConfig.form.logoTooltip': '支持 jpg/png/webp 等图片格式',
  'pages.bankConfig.form.logoUploadText': '点击上传',
  'pages.bankConfig.form.logoUploading': '上传中...',
  'pages.bankConfig.form.sortLabel': '排序',
  'pages.bankConfig.form.sortPlaceholder': '请输入排序值',
  'pages.bankConfig.form.descriptionLabel': '描述',
  'pages.bankConfig.form.descriptionMaxLength': '描述不能超过 500 个字符',
  'pages.bankConfig.form.descriptionPlaceholder': '请输入描述',
  'pages.bankConfig.message.fetchViewUrlFailed': '获取预览地址失败',
  'pages.bankConfig.message.fetchParentIdFailed': '获取父级字典失败',
  'pages.bankConfig.message.fetchSortFailed': '获取排序值失败',
  'pages.bankConfig.message.uploadSuccess': '上传成功',
  'pages.bankConfig.message.uploadFailed': '上传失败',
  'pages.bankConfig.message.systemError': '系统异常，请稍后重试',
  'pages.bankConfig.message.createSuccess': '新增成功',
  'pages.bankConfig.message.createFailed': '新增失败',
  'pages.bankConfig.message.updateSuccess': '更新成功',
  'pages.bankConfig.message.updateFailed': '更新失败',
  'pages.bankConfig.message.deleteSuccess': '删除成功',
  'pages.bankConfig.message.deleteFailed': '删除失败',
};
